<div class="col-sm-12 nopadding">
    <div class="col-sm-12 nopadding">
        <h2 class="border-btm">Action Required <button type="button" (click)="CloseModal()" class="close"></button></h2>

    </div>
    <div class="col-sm-12 nopadding">
        <form [formGroup]="modalForm" (submit)="SaveData()">
          <div class="row">
              <div class="col-sm-6" *ngIf="modalData.currentData.data.display_followup">
                <label class="form-label">Date *</label>
                <mat-form-field appearance="fill">
                    <mat-label>Choose a date</mat-label>
                    <input matInput readonly formControlName="dnp_followup_date" [matDatepicker]="picker" [min]="minDate">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <div *ngIf="submitted && f.dnp_followup_date.errors" class="invalid-feedback">
                    <div *ngIf="f.dnp_followup_date.errors.required">Date is required</div>
                </div>
            </div>
            <div class="col-sm-6" *ngIf="!modalData.currentData.data.paymentMode && (modalData.pagetype==2 || modalData.pagetype==3)">
              <div class="form-group">
                <label>Payment Mode</label>
                <mat-select  formControlName="payment_mode" placeholder="Select Payment Mode">
                    <mat-option>Select</mat-option>
                    <mat-option value="Cash">Cash</mat-option>
                    <mat-option value="Cashless">Cashless</mat-option>
                    <mat-option value="Reimbursement">Reimbursement</mat-option>
                    <mat-option value="EMI">EMI</mat-option>
                </mat-select>
              </div>
              <div *ngIf="submitted && f.payment_mode.errors" class="invalid-feedback">
                  <div *ngIf="f.payment_mode.errors.required">Select Payment Mode</div>
              </div>
            </div>
              <div class="col-sm-6" *ngIf="!modalData.currentData.data.treatment && (modalData.pagetype==2 || modalData.pagetype==3)">
                <div class="form-group">
                  <label>Treatment</label>
                  <mat-select placeholder="Select Treatment" formControlName="treatment">
                      <mat-option  [value]="treatment.id" *ngFor="let treatment of treatments">{{treatment.name}}</mat-option>
                  </mat-select>
              </div>
              <div *ngIf="submitted && f.treatment.errors" class="invalid-feedback">
                  <div *ngIf="f.treatment.errors.required">Select Treatment</div>
              </div>
            </div>
          </div>

        <div class="col-sm-12" *ngIf="modalData.pagetype==1 || modalData.pagetype==2">
          <div class="form-group">
              <label class="form-label">Comments</label>
              <textarea class="form-control" formControlName="comments"></textarea>
          </div>
          <div *ngIf="submitted && f.comments.errors" class="invalid-feedback">
              <div *ngIf="f.comments.errors.required">Comments is required</div>
          </div>
        </div>
            <div class="card-footer">
                <button style="margin-left: 15px;" type="submit" [disabled]="loading" class="btn btn-primary float-right" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i> Submit</button>
                <button type="button" (click)="CloseModal()" class="btn btn-default float-right">Close</button>
            </div>
        </form>
    </div>
</div>
